import { OrderViewModel } from '@order/models/order-view-model';
import { Tracking } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';
import { OrderAnalyticsMessages } from '../order-analytics.constants';

export const cartQuantityUpdateTracking = (
  quantityUpdate: any,
  vm: OrderViewModel,
): Tracking => {
  const orderItem = Object.keys(vm.orderItemState?.entities)
    ?.map(key => vm.orderItemState?.entities[key])
    .find(
      (oi: OrderItem) => quantityUpdate?.productNumber === oi.productNumber,
    );
  const isUqeOrderItem: boolean = vm.uqeCards?.some(
    uqe => uqe?.product?.productNumber === quantityUpdate?.productNumber,
  );

  let trackingData: Tracking;

  trackingData =
    isUqeOrderItem && !orderItem?.quantityAccepted
      ? {
          analytics: {
            data: {
              products: [
                {
                  addMethod: OrderAnalyticsMessages.exceptions,
                  exceptionCode: OrderAnalyticsMessages.uqe,
                },
              ],
            },
          },
        }
      : {
          analytics: {
            data: {
              products: [{ addMethod: OrderAnalyticsMessages.cart }],
            },
          },
        };
  const productOrdered = vm?.productsMap?.get(quantityUpdate?.productNumber);

  if (vm?.alternatives?.get(quantityUpdate?.productNumber)) {
    const divisionNumber = vm.orderHeader?.divisionNumber;
    const parentProductNumber = vm.alternatives.get(
      quantityUpdate?.productNumber,
    ).parentProductNumber;
    const divisionApn = divisionNumber + '-' + parentProductNumber;
    trackingData.analytics.data.products[0].subIn = 1;
    trackingData.analytics.data.products[0].substitutionParentApn = divisionApn;
    (trackingData.analytics.data.products as Array<any>).push({
      divisionApn: divisionApn,
      subOut: 1,
    });
  } else if (
    productOrdered?.alternative?.product?.productNumber &&
    vm?.alternatives?.has(productOrdered.alternative.product.productNumber)
  ) {
    trackingData.analytics.data.products[0].orderedOriginal = 1;
  }

  return trackingData;
};
